"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferPayloadToFormDataHandler = transferPayloadToFormDataHandler;
function transferPayloadToFormDataHandler(data) {
    return {
        dateOfTransfer: data.form.dateOfTransfer,
        hospitalTransferredTo: data.form.hospitalTransferredTo || "N/A",
        reasonForTransfer: data.form.reasonForTransfer || "N/A",
        caseManagerAtHospital: data.form.caseManagerAtHospital || "N/A",
        phoneNumberWithCountryCode: {
            countryCode: data.form.countryCode || "",
            phoneNumber: +(data.form.phoneNumberToCaseManager || 0),
        },
        faxNumberToHospital: data.form.faxNumberToHospital || "N/A",
        physicianNotified: data.form.physicianNotified,
        notes: data.form.comments || "",
    };
}
